import React from 'react';

import { Select } from 'scouting-ui';

import { intl } from '@shared/localization';

import styles from './RequirementsRenderer.module.scss';
import type { VersionOption } from './types';

interface VersionPickerProps {
  options: VersionOption[];
  selectedVersionId?: number;
  disabled?: boolean;
  loading?: boolean;
  onChange: (versionId: number) => void;
}

export default function VersionPicker(props: VersionPickerProps) {
  const { options, selectedVersionId, disabled, loading, onChange } = props;

  if (!options.length) return null;

  return (
    <div className={styles.versionPicker}>
      <Select
        id="qa_requirements_version"
        value={selectedVersionId}
        placeholder={intl.formatMessage({
          id: 'requirementsRenderer.version',
        })}
        // a switch already in flight must not accept another
        disabled={disabled || loading}
        loading={loading}
        onChange={onChange}
        options={options.map(option => ({
          value: option.versionId,
          label: `${option.version} (${intl.formatMessage({
            id: `requirementsRenderer.version.${option.timeFrame}`,
          })})`,
        }))}
      />
    </div>
  );
}
